import { useParams } from "react-router";

import { ProgramTabs } from "@/components/pages_logged_in/program/components/ProgramTabs";
import { FullRoleplaySession, FullScenario } from "@/types/roleplays";

export const ROLEPLAY_TABS_CONFIG = [
  {
    key: "analysis",
    label: "Analysis ",
    linkTo: "/roleplays/{roleplaySlug}/{scenarioSlug}/{sessionUuid}",
    secondLinkTo: "/scenarios/{scenarioSlug}/{sessionUuid}",
  },
  {
    key: "transcript",
    label: "Transcript ",
    linkTo: "/roleplays/{roleplaySlug}/{scenarioSlug}/{sessionUuid}/transcript",
    secondLinkTo: "/scenarios/{scenarioSlug}/{sessionUuid}/transcript",
  },
];

interface GetRoleplayTabsProps {
  roleplaySlug: string;
  scenarioSlug: string;
  sessionUuid: string;
  tabs?: typeof ROLEPLAY_TABS_CONFIG;
}

export function getRoleplayTabs({
  roleplaySlug,
  scenarioSlug,
  sessionUuid,
  tabs = ROLEPLAY_TABS_CONFIG,
}: GetRoleplayTabsProps) {
  return tabs.map((item) => {
    let linkTo = item.linkTo || "";
    let secondLinkTo = item.secondLinkTo || "";

    if (roleplaySlug) {
      linkTo = linkTo.replace("{roleplaySlug}", roleplaySlug);
    }

    if (scenarioSlug) {
      if (roleplaySlug) {
        linkTo = linkTo.replace("{scenarioSlug}", scenarioSlug);
      } else {
        linkTo = secondLinkTo.replace("{scenarioSlug}", scenarioSlug);
      }
    }

    if (sessionUuid) {
      linkTo = linkTo.replace("{sessionUuid}", sessionUuid);
    }

    return { ...item, linkTo: linkTo };
  });
}

interface RoleplaySessionTabsProps {
  scenario?: FullScenario;
  roleplaySession?: FullRoleplaySession;
  roleplaySlug?: string;
  view?: string;
}

export function RoleplaySessionTabs({
  roleplaySlug,
  scenario,
  roleplaySession,
  view = "analysis",
}: RoleplaySessionTabsProps) {
  const params = useParams();

  const tabs = getRoleplayTabs({
    roleplaySlug: roleplaySlug ?? params.roleplaySlug ?? "",
    scenarioSlug: scenario?.slug ?? params.scenarioSlug ?? "",
    sessionUuid: roleplaySession?.uuid ?? params.sessionUuid ?? "",
  });
  const selectedTab = tabs.find((tab) => tab.key === view) || tabs[0];

  return <ProgramTabs tabs={tabs} initialTab={selectedTab.key} marginTop={0} />;
}
